module.exports = __webpack_public_path__ + "static/media/mmnm-vudici.759b4ed7.jpg";